import {
  Box,
  Skeleton,
  Stack,
  SvgIconTypeMap,
  Typography,
  useTheme,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { AnimatePresence, motion } from 'framer-motion';
import { ReactElement, ReactNode } from 'react';
import { IconType } from 'react-icons/lib';

export interface TitleProps {
  children?: ReactNode | ReactElement;
  loading?: boolean;
  Icon?:
    | (OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
        muiName: string;
      })
    | IconType;
}

export const Title = ({ children, Icon, loading }: TitleProps) => {
  const theme = useTheme();

  const isMuiIcon = (
    icon: any
  ): icon is OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
    muiName: string;
  } => {
    return icon && 'type' in icon;
  };

  const renderIcon = () => {
    if (!Icon) return null;

    if (isMuiIcon(Icon)) {
      return (
        <Icon sx={{ fontSize: 32, color: theme.palette.error.main, mr: 0.5 }} />
      );
    } else {
      return (
        <Box sx={{ mr: 0.5 }}>
          <Icon size={32} color={theme.palette.error.main} />
        </Box>
      );
    }
  };

  return (
    <Stack flexDirection='row' alignItems='center' width='100%'>
      {renderIcon()}
      <AnimatePresence mode='popLayout'>
        {loading ? (
          <Skeleton
            layout
            component={motion.span}
            sx={{ width: { xs: '100%', lg: 400 } }}
            height={38}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />
        ) : (
          <Typography
            layout
            color={theme.palette.error.main}
            fontWeight={600}
            component={motion.p}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            sx={{
              width: '100%',
              display: 'inline-block',
              alignItems: 'center',
              fontSize: '2rem',
            }}
          >
            {children}
          </Typography>
        )}
      </AnimatePresence>
    </Stack>
  );
};
